export default __webpack_public_path__ + "img/8adf227d4d31f4dc46f0e3e53274c2f1.svg";